import Dashboard from "../../../components/Dashboard/Dashboard";
import { comparisonDashboardConfigs } from "../../../config/dashboardConfigs";

const config = comparisonDashboardConfigs.opening;

export default function ComparisonOpeningDashboard() {
  return <Dashboard {...config} />;
}
